import {
  AppBar,
  Box,
  Breadcrumbs,
  Button,
  CircularProgress,
  Container,
  Toolbar,
  Link,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Stack,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Collapse,
  Tooltip,
} from "@mui/material";
import { BackButton, HelpButton } from "./Buttons";
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import HelpFixComponent from "./HelpFixComponent";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  helpFixState,
  trainStatusInfoState,
  autoFillDataState,
  trainingState,
} from "../recoil";
import MenuButton from "./MenuButton";
import { Fragment, useEffect, useState, useMemo } from "react";
import { getProject, getProjectGeneralInfo } from "../services/projectService";
import { getTrainStop, stopTrain } from "../services/trainService";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { getAIInfo } from "../services/serverService";
import aiInfoResponse from "../datas/aiInfoResponse.json";
import QueueCheckTable from "./QueueCheckTable";
import {
  ChevronRightIcon,
  ExpandLessIcon,
  ExpandMoreIcon,
  MenuBookIcon,
  StopIcon,
} from "../icons";
import { QueueItem } from "../@types";
import HighlightBox from "./customComponent/CustomHighlightBox";
import { truncateString } from "common-lib";
import ManualModal from "./ManualModal";

export const ServerModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  // height: "300px",
  height: "fit-content",
  display: "flex",
  flexDirection: "column",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  userSelect: "none",
};

export default function Header() {
  const { t } = useTranslation();
  const { id } = useParams();
  const helpFix = useRecoilValue(helpFixState);
  const navigate = useNavigate();
  const currentPath = window.location.href;
  const [projectName, setProjectName] = useState<string>(t("Home"));
  const [step, setStep] = useState<string>("");
  const [trainStatusInfo, setTrainStatusInfo] =
    useRecoilState(trainStatusInfoState);
  const [serverStatusMapping, setServerStatusMapping] = useState<any[]>([]);
  const [trainStatus, setTrainStatus] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [autoFillData, setAutoFillData] = useRecoilState(autoFillDataState);
  const [isTrain, setIsTrain] = useRecoilState(trainingState);
  const [openServerModal, setOpenServerModal] = useState<boolean>(false);
  const [breadcrumbsState, setBreadcrumbsState] = useState<[]>([]);
  const [isStop, setIsStop] = useState(false);
  const [openManual, setOpenManual] = useState<boolean>(false);
  const location = useLocation();

  const [imgSize, setImgSize] = useState<string>("400px");
  const breadcrumbs = [
    <Link
      key="1"
      color="inherit"
      to="/home"
      underline="none"
      component={RouterLink}
    >
      {t("Home")}
    </Link>,
    step === "분석" ? (
      <Link
        key="2"
        color="inherit"
        to={`/project/${id}/analysis`}
        underline="none"
        component={RouterLink}
      >
        {/* {t("Analysis")} */}
        <Typography key="2">{truncateString(projectName, 15)}</Typography>
      </Link>
    ) : (
      <Link
        key="2"
        color="inherit"
        to={`/project/${id}`}
        underline="none"
        component={RouterLink}
      >
        {/* {t("Classification")} */}
        <Typography key="2">{truncateString(projectName, 15)}</Typography>
      </Link>
    ),
    currentPath.includes("/setting") && (
      <Link
        key="3"
        color="inherit"
        to={`/project/${id}/setting`}
        underline="none"
        component={RouterLink}
      >
        {t("Setting")}
      </Link>
    ),
    currentPath.includes("/report") && (
      <Link
        key="3"
        color="inherit"
        to={`/project/${id}/report`}
        underline="none"
        component={RouterLink}
      >
        {t("Report")}
      </Link>
    ),
    currentPath.includes("/history") && (
      <Link
        key="3"
        color="inherit"
        to={`/project/${id}/history`}
        underline="none"
        component={RouterLink}
      >
        {t("History")}
      </Link>
    ),
  ].filter(Boolean);

  const navigateHome = () => {
    navigate("/home");
    // navigate("/main/dashboard");
    setAutoFillData([]);
  };

  const navigateSetting = () => {
    navigate("/setting");
  };

  useEffect(() => {
    const getProjectData = async () => {
      if (currentPath.includes("project") && id) {
        const projectData = await getProjectGeneralInfo(Number(id));
        setProjectName(projectData.project.project_name);
        setStep(projectData.project.step);
      } else {
        setProjectName(t("Home"));
      }
    };
    getProjectData();
  }, [id]);

  useEffect(() => {
    if (trainStatusInfo.trainProjectId === Number(id)) {
      switch (trainStatusInfo.status) {
        case "None":
          setTrainStatus("");
          break;
        case "Init":
          setTrainStatus("학습 초기화 진행중");
          break;
        case "Calc":
          setTrainStatus("계산중");
          break;
        case "Train":
          setTrainStatus("학습 진행중");
          break;
        case "Stopping":
          setTrainStatus("학습 중단중");
          break;
        default:
          setTrainStatus("");
          break;
      }
    } else {
      setTrainStatus("");
    }

    if (trainStatusInfo.code === 1) {
      setTrainStatus("");
    }
  }, [trainStatusInfo, id]);

  useEffect(() => {
    const handleResize = () => {
      setImgSize(window.innerWidth > 1250 ? "400px" : "300px");
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isStop) {
      fetchAIServer();
      setIsStop(false);
    }
  }, [isStop]);

  const handleTrainClick = async () => {
    if (
      trainStatusInfo.status !== "Stopping" &&
      trainStatusInfo.status !== "None"
    ) {
      if (window.confirm("진행중인 학습을 중단하시겠습니까?")) {
        try {
          await getTrainStop("192.168.2.29:30003");
          toast.success("학습 중단 진행중입니다.");
        } catch (error) {
          console.error(error);
          toast.error("학습 중단에 실패하였습니다.");
        }
      }
    } else {
      toast.warning(
        "해당 프로젝트에 대한 학습이 중단 진행중입니다. 자세한 사항은 `서버상태 확인`에서 확인해주세요."
      );
    }
  };

  // 드롭다운 메뉴 열기
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  // 드롭다운 메뉴 닫기
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    const access_token = localStorage.getItem("access_token");
    const refresh_token = localStorage.getItem("refresh_token");
    if (access_token) {
      localStorage.removeItem("access_token");
    }
    if (refresh_token) {
      localStorage.removeItem("refresh_token");
    }
    localStorage.removeItem("userInfo");
    navigate("/login");
  };

  const fetchAIServer = async () => {
    try {
      const response = await getAIInfo();
      const serverStatus = response.data.map((item: any) => ({
        server: item.server,
        state: item.train?.state,
        trainLog_id: item.train?.trainLog_id,
        train_time: item.train?.train_time,
        total_time: item.train?.total_time,
        project_name: item.train?.project_name,
        queue: item.queue,
      }));
      const queueList = serverStatus
        .filter(
          (item: any) => Array.isArray(item.queue) && item.queue.length > 0
        )
        .flatMap((item: any) => item.queue);

      setSelectedQueue(queueList);
      if (queueList.length > 0) {
        setOpenRowIndex(0);
      } else {
        setOpenRowIndex(null);
      }
      // console.log("serverStatus", serverStatus);
      // console.log("projectName", projectName);
      setServerStatusMapping(serverStatus);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCheckServer = () => {
    fetchAIServer();
    setOpenServerModal(true);
    getAIInfo();
    setIsTrain(false);
  };

  const [openRowIndex, setOpenRowIndex] = useState<number | null>(null);
  const [selectedQueue, setSelectedQueue] = useState<QueueItem[]>([]);

  const handleQueueTable = (server: trainSimpleStatus, index: number) => {
    // console.log("server", server.queue);
    setSelectedQueue(server.queue);
    setOpenRowIndex((prev) => (prev === index ? null : index));
  };

  const handleStopTrain = async (server: any) => {
    // console.log(server);
    if (window.confirm("해당 학습을 중단하시겠습니까?")) {
      try {
        const response = await stopTrain(server.trainLog_id);
        toast.success(response.msg);
        fetchAIServer();
      } catch (error) {
        toast.error("학습 중단에 실패하였습니다. 다시 시도해주세요.");
        console.error(error);
      }
    }
  };

  return (
    <Box sx={{ display: "flex", height: "80vh" }}>
      <Box sx={{ width: "100%" }}>
        <AppBar
          sx={{
            position: "fixed",
            height: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "var(--dk-surface, white)",
            backgroundColor: "var(--header-bg-color)",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <Toolbar
            sx={{
              pr: 3,
              pl: 3,
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  justifyContent: "flex-start",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-color)",
                      "@media (max-width: 1210px)": {
                        fontSize: "16px",
                        width: "90px",
                      },
                    }}
                    fontWeight="bold"
                    fontSize="20px"
                  >
                    {t("DataDASolution")}
                  </Typography>
                  {currentPath.includes("/project") && (
                    <HighlightBox isHighlight={isTrain}>
                      <Button
                        // variant="none"
                        sx={{
                          color: "var(--icon-color)",
                          width: "fit-content",
                          height: "30px",
                          size: "small",
                          p: "5px",
                          ml: "13px",
                          "@media (max-width: 1210px)": {
                            fontSize: "12px",
                            ml: "5px",
                          },
                        }}
                        className="steps_2_6"
                        onClick={handleCheckServer}
                      >
                        {t("CheckServerStatus")}
                        <ChevronRightIcon
                          sx={{
                            color: "var(--icon-color)",
                            fontSize: "16px",
                            "@media (max-width: 1210px)": {
                              fontSize: "12px",
                            },
                          }}
                        />
                      </Button>
                    </HighlightBox>
                  )}
                  {trainStatusInfo.trainProjectId === Number(id) &&
                    trainStatusInfo.status !== "None" && (
                      <Button
                        onClick={handleTrainClick}
                        variant="outlined"
                        sx={{
                          color: "var(--header-color)",
                          borderColor: "var(--header-color)",
                          width: "fit-content",
                          height: "30px",
                          ml: "5px",
                          size: "small",
                          p: "5px",
                          gap: 1,
                          "&:hover": {
                            background: "var(--header-hover-bg)",
                            borderColor: "var(--header-hover-bg)",
                          },
                          "@media (max-width: 1210px)": {
                            fontSize: "12px",
                          },
                        }}
                      >
                        <CircularProgress color="inherit" size="16px" />
                        {trainStatus}
                      </Button>
                    )}
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  {/* TODO: step 수정 */}
                  <Box className="steps_2_5">
                    {/* <Box> */}
                    {currentPath.includes("/project") && (
                      <>
                        <MenuButton step={step} />
                      </>
                    )}
                  </Box>
                  {currentPath.includes("/project") && <BackButton />}
                  {currentPath.includes("/project") && id && (
                    <Breadcrumbs
                      separator="›"
                      aria-label="breadcrumb"
                      sx={{
                        ml: 2,
                        border: "1px solid var(--icon-color)",
                        p: 0.3,
                        borderRadius: 1,
                        color: "var(--icon-color)",
                        "@media (max-width: 1210px)": {
                          "& span": {
                            fontSize: "12px",
                          },
                          "& .MuiTypography-root": {
                            fontSize: "12px",
                            marginTop: "3px",
                          },
                        },
                      }}
                    >
                      {breadcrumbs.map((item, index) => (
                        <span
                          key={index}
                          style={{
                            color:
                              index === breadcrumbs.length - 1
                                ? "var(--icon-color)"
                                : "inherit",
                            fontWeight:
                              index === breadcrumbs.length - 1
                                ? "bold"
                                : "normal",
                          }}
                        >
                          {item}
                        </span>
                      ))}
                    </Breadcrumbs>
                  )}
                </Box>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {/* <Typography variant="body1" sx={{ cursor: "pointer" }}>
                    {projectName}
                  </Typography> */}
                <Box>
                  <img
                    src="/logo.png"
                    alt="LOGO"
                    style={{
                      width: imgSize,
                      cursor: "pointer",
                    }}
                    onClick={navigateHome}
                  />
                </Box>
              </Box>

              <Box sx={{ flex: 1, display: "flex", alignItems: "flex-end" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    marginLeft: "auto",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {location.pathname.includes("/project/") ? (
                      <Button
                        onClick={() => navigate(`/main/project/${id}`)}
                        sx={{ color: "var(--dk-text, #000)", border: "1px solid #000" }}
                      >
                        신규 프로젝트
                      </Button>
                    ) : location.pathname.includes("/create") ? (
                      <Button
                        onClick={() => navigate(`/main/projects/create`)}
                        sx={{ color: "var(--dk-text, #000)", border: "1px solid #000" }}
                      >
                        신규버전
                      </Button>
                    ) : (
                      <Button
                        onClick={() => navigate(`/main/dashboard`)}
                        sx={{ color: "var(--dk-text, #000)", border: "1px solid #000" }}
                      >
                        신규버전
                      </Button>
                    )}
                    <HelpButton />
                    <IconButton
                      onClick={() => setOpenManual(true)}
                      sx={{ color: "var(--icon-color)" }}
                    >
                      <MenuBookIcon />
                    </IconButton>
                    <Stack direction="row">
                      <Avatar
                        sx={{
                          cursor: "pointer",
                          backgroundColor: "var(--main-bg-color)",
                        }}
                        onClick={handleMenuClick}
                      >
                        <PersonIcon sx={{ color: "var(--icon-color)" }} />
                        {/* TODO: 사용자 이미지 넣으면 해당 이미지로 변경되게 해도 좋을듯 */}
                      </Avatar>
                    </Stack>
                  </Box>

                  <Menu
                    anchorEl={anchorEl} // 드롭다운 메뉴의 위치
                    open={Boolean(anchorEl)} // 메뉴 열림 여부
                    onClose={handleMenuClose} // 메뉴 닫기
                    anchorOrigin={{
                      vertical: "bottom", // 드롭다운이 열리는 위치
                      horizontal: "right", // 오른쪽 끝에서 열리도록 설정
                    }}
                    transformOrigin={{
                      vertical: "top", // 드롭다운이 닫히는 위치
                      horizontal: "right", // 오른쪽 끝에서 닫히도록 설정
                    }}
                    sx={{
                      position: "absolute",
                    }}
                  >
                    {/* <MenuItem onClick={handleMenuClose}>
                      프로필(구현예정)
                    </MenuItem>{" "} */}
                    {/* 드롭다운 메뉴 항목 */}
                    <MenuItem onClick={navigateSetting}>설정</MenuItem>
                    <MenuItem onClick={handleLogout}>로그아웃</MenuItem>
                  </Menu>
                </Box>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
        <Container
          component="main"
          maxWidth="xl"
          sx={{
            display: "flex",
            flex: 1,
            height: "970px",
            mt: "100px",
          }}
        >
          <Outlet />
        </Container>
      </Box>
      {helpFix && (
        <Box
          id="help-box"
          sx={{
            width: "500px",
            height: "100vh",
            borderLeft: "1px solid var(--dk-border, #ccc)",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <HelpFixComponent />
        </Box>
      )}
      {openServerModal && (
        <>
          <Modal
            open={openServerModal}
            onClose={() => {
              setOpenServerModal(false);
              setOpenRowIndex(null);
              setSelectedQueue([]);
            }}
          >
            <Box sx={ServerModalStyle}>
              <TableContainer>
                <Table>
                  <TableHead
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      "& .MuiTableCell-root": {
                        color: "var(--scm-color)",
                      },
                      backgroundColor: "var(--scm-table-bgcolor)",
                    }}
                  >
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", fontSize: "15px" }}>
                        Server
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          fontSize: "15px",
                          width: "200px",
                        }}
                      >
                        Project
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", fontSize: "15px" }}>
                        Status
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", fontSize: "15px" }}>
                        Message
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", fontSize: "15px" }}>
                        Queue
                      </TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {serverStatusMapping.map((server, index) => (
                      <Fragment key={index}>
                        <TableRow>
                          <TableCell>{server.server || "-"}</TableCell>
                          <Tooltip
                            title={server.project_name || "-"}
                            placement="top"
                            PopperProps={{
                              modifiers: [
                                {
                                  name: "offset",
                                  options: {
                                    offset: [0, -30],
                                  },
                                },
                              ],
                            }}
                          >
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                              }}
                            >
                              <Typography
                                sx={{
                                  minHeight: "30px",
                                  // minWidth: "70px",
                                  width: "150px",
                                  pl: 0.5,
                                  // border:
                                  //   projectName === server.project_name
                                  //     ? "solid 1px gray"
                                  //     : "",
                                  // borderRadius:
                                  //   projectName === server.project_name
                                  //     ? "5px"
                                  //     : "",
                                }}
                              >
                                {truncateString(server.project_name, 12) || "-"}
                              </Typography>
                            </TableCell>
                          </Tooltip>
                          <TableCell>{server.state || "-"}</TableCell>
                          <TableCell>{server.message || "-"}</TableCell>
                          <TableCell>
                            {server.queue.length > 0 ? (
                              <IconButton
                                onClick={() => handleQueueTable(server, index)}
                              >
                                {openRowIndex === index ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )}
                              </IconButton>
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          <TableCell>
                            {server.state !== "stopping" &&
                              server.state !== "none" && (
                                <IconButton
                                  onClick={() => {
                                    handleStopTrain(server);
                                  }}
                                >
                                  <StopIcon />
                                </IconButton>
                              )}
                          </TableCell>
                        </TableRow>

                        {openRowIndex === index && (
                          <TableRow>
                            <TableCell colSpan={6} sx={{ padding: 0 }}>
                              {openRowIndex === index && (
                                <QueueCheckTable
                                  projectId={id}
                                  selectedQueue={selectedQueue}
                                  setIsStop={setIsStop}
                                />
                              )}
                            </TableCell>
                          </TableRow>
                        )}
                      </Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Modal>
        </>
      )}
      {openManual && (
        <ManualModal openManual={openManual} setOpenManual={setOpenManual} />
      )}
    </Box>
  );
}
